export default __webpack_public_path__ + "static/media/Belt of the Stormbringer.c62d8128.jpg";